riot.tag2('filter-select', '<label class="input-select distance-input filter-custom-select {\'is-open\': isOpen}"> <span class="filter-custom-select-copy" onclick="{toggleSelect}"> {selectedDistanceLabel} {\'miles\': selectedDistance !== false} </span> <ul class="filter-custom-select-options"> <li class="filter-custom-select-option {\'is-selected\': selectedDistance === distance.value}" each="{distance in filterDistance}" onclick="{selectOption}" data-tracking="{trackingDataFilterSelect}"> {distance.value} {\'miles\': distance.value !== filterDistance[0].value} </li> </ul> <i class="filter-custom-select-icon distance-icon"></i> </label>', '', '', function(opts) {
    var self = this;
    var trackingJSON = require('../../data/tracking-data');

    self.selectedDistance = false;
    self.selectedDistanceLabel = self.filterDistance[0].value;
    self.trackingDataFilterSelect = JSON.stringify(trackingJSON.filteringByDistance);

    function toggleSelect() {
      self.isOpen = !self.isOpen;

      self.update();
    }

    function selectOption() {
      self.isOpen = false;
      self.selectedDistance = (self.filterDistance[0].value !== this.distance.value)
        ? this.distance.value
        : false;
      self.selectedDistanceLabel = this.distance.value;

      self.update();
    }

    self.isOpen = false;
    self.toggleSelect = toggleSelect;
    self.selectOption = selectOption;
});
